import { AfterViewChecked, AfterViewInit, Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { VisualizadorService } from 'src/app/components/shared/service/visualizador.service';

@Component({
  selector: 'app-mega-menu',
  templateUrl: './mega-menu.component.html',
  styleUrls: ['./mega-menu.component.css']
})
export class MegaMenuComponent implements OnInit, AfterViewChecked {

  public htmlMegaMenu!: SafeHtml;
  public htmlReady: boolean = false;

  constructor(private service: VisualizadorService, private sanitizer: DomSanitizer, private renderer: Renderer2, private el: ElementRef) { }

  ngOnInit(): void {
    this.service.getMegaMenu().subscribe({
      next: (response) => {
        this.htmlMegaMenu = this.sanitizer.bypassSecurityTrustHtml(response);
        this.htmlReady = true;
      },
      error: (error) => {
        console.log("Error inesperado en consultaParametro", error);
      }
    });
  }

  ngAfterViewChecked(): void {
    if (this.htmlReady) {
      this.runScripts();
    }
  }

  private runScripts() {
    const scripts = this.el.nativeElement.querySelectorAll('script');
    scripts.forEach((script: HTMLScriptElement) => {
      const newScript = this.renderer.createElement('script');
      newScript.type = 'text/javascript';
      newScript.text = script.textContent || '';
      this.renderer.appendChild(this.el.nativeElement, newScript);
    });
    this.htmlReady = false;
  }

}
